export default __webpack_public_path__ + "static/exclamation-mark-0fc27dfc7175438a01a64918c8a6339f.svg";